import React, { useState, useEffect } from 'react';
import './Validation.css';
import { useNavigate } from 'react-router-dom';

const BASE_URL = process.env.REACT_APP_BACKEND_URL2;

function PhoneLogin() {
  const navigate = useNavigate();

  const [phone, setPhone] = useState('');
  const [showOTP, setShowOTP] = useState(false);
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [isLoading, setIsLoading] = useState(false);
  const [countdown, setCountdown] = useState(180);

  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown]);

  const handleSendOTP = async () => {
    if (phone.trim().length !== 10) {
      alert('Please enter a valid 10-digit phone number.');
      return;
    }

    setIsLoading(true);
    try {
      const response = await fetch(`${BASE_URL}/login/request-otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: `+91${phone.trim()}` })
      });

      const data = await response.json();

      if (!response.ok) {
        alert(data.message || 'Failed to send OTP');
        return;
      }

      setShowOTP(true);
      setCountdown(180);
    } catch (err) {
      alert('Network error occurred.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleOTPChange = (index, value) => {
    if (isNaN(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value.slice(-1);
    setOtp(newOtp);

    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`)?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`)?.focus();
    }
  };

  const handleVerifyOTP = async () => {
    const fullOtp = otp.join('');
    if (fullOtp.length !== 6) return;

    setIsLoading(true);

    const getQueryParams = () => {
      if (window.location.hash.includes("?")) {
        return new URLSearchParams(window.location.hash.split("?")[1]);
      }
      return new URLSearchParams(window.location.search);
    };

    const params = getQueryParams();

    try {
      const response = await fetch(`${BASE_URL}/login/forgotpassword/confirm`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: `+91${phone.trim()}`,
          otp: fullOtp,
          params: {
            client_id: params.get("client_id"),
            redirect_uri: params.get("redirect_uri"),
            state: params.get("state"),
            alexa: true
          }
        })
      });

      const data = await response.json();

      if (!response.ok) {
        alert(data.message || 'Invalid OTP');
        return;
      }

      if (data.redirect_uri && data.code) {
        window.location.href =
          `${data.redirect_uri}?code=${data.code}&state=${data.state}`;
        return;
      }

      localStorage.setItem('authToken', data.tokens?.IdToken || '');
      localStorage.setItem('refreshToken', data.tokens?.RefreshToken || '');
      localStorage.setItem('accessToken', data.tokens?.AccessToken || '');
      localStorage.setItem('userSub', data.jwtsub || '');
      localStorage.setItem('userDetails', JSON.stringify(data.user || {}));
      localStorage.setItem('userRole', data.user?.userrole || '');

      navigate(data.user?.userrole === "customer" ? '/cuspage' : '/dashboard');

    } catch (err) {
      alert('Verification failed.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h2>{showOTP ? 'Verify Your Identity' : 'AIZO HOME'}</h2>
          <p className="modal-subtitle">
            {showOTP
              ? 'Enter the 6-digit code sent to your phone'
              : 'Sign in to access your account'}
          </p>
        </div>


        {!showOTP ? (
          <div className="modal-body">
            <div className="form-group">
              <label>Phone Number</label>
              <div className="input-with-prefix">
                <span className="prefix">+91</span>
                <input
                  type="tel"
                  maxLength="10"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder="Enter your phone number"
                />
              </div>
            </div>

            <button
              className="primary-btn"
              onClick={handleSendOTP}
              disabled={isLoading}
            >
              {isLoading ? <span className="spinner" /> : 'Continue'}
            </button>

            {/* Privacy Line */}
            <p className="privacy-text">
              By continuing, you agree to AIZO HOME’s{" "}
              <a href="https://aizoplug.com/privacy_policy.html" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>.
            </p>
          </div>
        ) : (
          <div className="modal-body">
            <div className="otp-container">
              {otp.map((digit, i) => (
                <input
                  key={i}
                  id={`otp-${i}`}
                  type="tel"
                  maxLength="1"
                  value={digit}
                  onChange={(e) => handleOTPChange(i, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(e, i)}
                  autoFocus={i === 0}
                />
              ))}
            </div>

            <button
              className="primary-btn"
              onClick={handleVerifyOTP}
              disabled={isLoading || otp.includes('')}
            >
              {isLoading ? <span className="spinner" /> : 'Verify'}
            </button>

            {/*Privacy Line */}
            <p className="privacy-text">
              By continuing, you agree to AIZO HOME’s{" "}
              <a href="https://aizoplug.com/privacy_policy.html" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>.
            </p>

            <p className="resend-text">
              {countdown > 0
                ? `Resend code in ${Math.floor(countdown / 60)}:${String(countdown % 60).padStart(2, '0')}`
                : <a href="#" onClick={handleSendOTP}>Resend code</a>}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default PhoneLogin;
